import { Card, CardContent } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { objOf, pick, prop, propOr } from "ramda";
import { Layout } from "../../components/Layout";
import { useMsg } from "../../components/Msg/Msg";
import { useMyMutation, useMyQuery } from "../Authorization/AuthProvider";
import {
  SaveableNote,
  saveableNoteMessages,
} from "../SaveableNote/SaveableNote";
import { dashboardMessages } from "../Dashboard/messages";

const useNoteQuery = () =>
  useMyQuery({
    queryKey: ["user-info", "notes"],
    fetchDef: {
      url: "/api/latest/user-info/notes",
    },
  });

const useNoteMutation = () => {
  const queryClient = useQueryClient();
  return useMyMutation({
    fetchDef: {
      method: "POST",
      url: `/api/latest/user-info/notes`,
      from: pick(["notes"]),
    },
    invalidate: { queryKey: ["user-info", "notes"] },
    snackbar: { success: false, error: true },
    onSettled: (data, error, variables, context) => {
      console.log("useNoteMutation", { data, error, variables, context });
      if (data)
        queryClient.setQueryData(["user-info", "notes"], (old) => {
          console.log({ variables, old, data });
          return { ...data };
        });
    },
  });
};

export const NotesPage = () => {
  const notesMsg = useMsg({ dict: saveableNoteMessages });
  const dashboardMsg = useMsg({ dict: dashboardMessages });
  const query = useNoteQuery();
  const mutation = useNoteMutation();

  return (
    <Layout header={{ heading: notesMsg("notes.title") }}>
      <Card>
        <CardContent>
          <SaveableNote
            title={dashboardMsg("dashboard.cards.notes.title")}
            placeholder={dashboardMsg(
              "dashboard.cards.notes.placeholder.empty",
            )}
            query={query}
            to={propOr("", "notes")}
            mutation={mutation}
            from={objOf("notes")}
          />
        </CardContent>
      </Card>
    </Layout>
  );
};
